import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page66() {
  useEffect(() => {
    document.title = "Маяк — Страница 65"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page64" />
        <ForwardLink href="/page66" />
      </div>

      <p style={{ textAlign: "right" }}>65.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Возвращайся к своим обязанностям, или я протащу<br/>
        тебя под килем.
      </p>
      <p>Пауза.</p>
      <p>МОЛОДОЙ стоит неподвижно, размышляя.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты ведь уже даже и не человек.<br/>
        Так долго работаешь вдали от людей.<br/>
        Что с тобой не так?
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Тебя можно терпеть только, когда ты пьян.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Иди работать, я сказал!
      </p>
      <p>МОЛОДОЙ СТОИТ НЕПОДВИЖНО, ВЫЗЫВАЮЩЕ.</p>
      <p>КАМЕРА ПОКАЗЫВАЕТ: НОЖ ВСЕ ЕЩЕ СПРЯТАН В РУКЕ МОЛОДОГО.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        За работу!
      </p>
      <p>Пауза.</p>
      <p>СТАРИК <u>ПЕРДИТ</u>.</p>
      <p>МОЛОДОЙ УЛЫБАЕТСЯ СНОВА, СТРАННОЙ, ФАЛЬШИВОЙ УЛЫБКОЙ.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ТРОПИНКА – ДЕНЬ</p>
      <p>
        МОЛОДОЙ, одетый в КЛЕЕНЧАТЫЙ ПЛАЩ, толкает тачку сквозь<br/>
        бурю. Это почти невозможно. Он пьян или с похмелья?
      </p>
      <p>ОН БОРМОЧЕТ ПРО СЕБЯ.</p>
      <p>
        У него БУТЫЛКА в тачке, плавающая в дождевой воде. Это<br/>
        все. Никакого угля. МОЛОДОЙ не спускает глаз с бутылки. Наблюдает за ней.<br/>
        Ухаживает.
      </p>
      <br/>
      <p>ВНУТРИ. ЗДАНИЕ ФОГОРНА – ДЕНЬ</p>
      <p>Механизм маяка вращается, качает и... РЕВЕТ!</p>
      <p>
        МОЛОДОЙ закидывает в печь кучу угля. Рубашка снята.<br/>
        КЛЕЕНЧАТАЯ ШЛЯПА на голове.
      </p>
      <p style={{ textAlign: "right" }}>65.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page64" />
        <ForwardLink href="/page66" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710632306/the-lighthouse-script/lchez0zegc8s402yfdeo.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page66;
